import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class Utils {

  static getFormUrlEncoded(obj: Object) {
    const formBody = [];
    for (const property of Object.keys(obj)) {
      const encodedKey = encodeURIComponent(property);
      const encodedValue = encodeURIComponent(obj[property]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    return formBody.join('&');
  }

  static downloadFile(blob, name) {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    const newBlob = new Blob([blob], { type: 'application/pdf' });

    // commenting this out since IE is not used anymore
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    // Legacy IE support - commented out as IE is no longer supported
    // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //   window.navigator.msSaveOrOpenBlob(newBlob);
    //   return;
    // }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);
    const link = document.createElement('a');
    link.href = data;
    link.download = name;
    link.click();
    setTimeout(function () {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
    }, 100);
  }
}


// Supported hostname mappings are documented in ArkAi/development-apps.md (Client Portal tenant hostnames).
// Returns null when the hostname is not mapped to a company, so callers never fall back to another company.
export function getClientFromUrl(): string | null {
  const host = window.location.hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'localhost';
  }
  if (host === 'client.optomiser.com') {
    return 'bihs';
  }
  if (host === 'client.optomiser-development.com') {
    return 'beta';
  }
  const match = /^client-([a-z0-9]+)\.optomiser(-development)?\.com$/.exec(host);
  return match ? match[1] : null;
}

export const UNKNOWN_CLIENT_MESSAGE = 'We could not find a Client Portal at this address. Please check that the web address (URL) is typed correctly and try again.';

export function mergeObjects(obj1, obj2): any {
  const answer = {};
  for (const key in obj1) {
    if (answer[key] === undefined || answer[key] === null) {
      answer[key] = obj1[key];
    }
  }
  for (const key in obj2) {
    if (answer[key] === undefined || answer[key] === null) {
      answer[key] = obj2[key];
    }
  }
  return answer;
}

export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}
